module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/repertorio_pic_pro.a7330f36.png";